import http from './http';

export function getLoginInfo() {
  return http.get('/Account/GetLoginUserInfo');
}
